import layout from '@/layout'

export default {
  path: '/pre_close_in',
  component: layout,
  redirect: '/pre_close_in/page8',
  name: 'pre_close_in_page8',
  meta: {
    title: 'pre_close_in',
    icon: 'el-icon-d-arrow-right'
  },
  children: [
    {
      path: '/pre_close_in/page8',
      name: 'pre_close_in_page8',
      component: () => import('@/views/pre_settle/pre_close/in/index8'),
      meta: {
        title: 'pre_close_in_page8',
        icon: 'el-icon-d-arrow-right'
      }
    }
  ]
}
